module.exports = __webpack_public_path__ + "media/images/svg/manifest_title-6afb5ad11e67ec4dcd43bdb81ed9e5d9.svg";